import { isServer } from 'lib'

export const getClientTagsFromURL = () => {
	if (isServer()) {
		return {}
	} else {
		const urlParams = new URLSearchParams(window.location.search)
		const tagParams = {} as { [key: string]: string }
		urlParams.forEach((value, key) => {
			if (key.indexOf('tag.') === 0) {
				tagParams[key] = value
			}
		})
		return tagParams
	}
}
